// extracted by mini-css-extract-plugin
export default {"cls1":"AAfNkuLtPuxGSix5va5J","cls2":"SszIqAELFmoYkyNjcZCJ AAfNkuLtPuxGSix5va5J"};